import React from 'react';
import Proptypes from 'prop-types';
import style from './index.scss';
import { Button, List, message, Layout } from 'antd';
import { ConfirmModal } from '../ConfirmModal';
import {
  clearUploadTypologies,
  confirmUploadedTypologies,
  discardUploadedTypologies
} from '../../../../redux/actions/trm/trmDashboard';
import { connect } from 'react-redux';

export const UPLOAD_CONFIRM = 'UPLOAD_CONFIRM';
export const UPLOAD_DISCARD = 'UPLOAD_DISCARD';
const { Content } = Layout;
/**
 * UploadDataList Class Widget
 */
class UploadDataList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isConfirmed: false
    };
  }

  /**
   * getDerivedStateFromProps
   * @param props
   * @param state
   * @returns {{isConfirmed: boolean}|null}
   */
  static getDerivedStateFromProps(props, state) {
    const { trmDashboard } = props;
    const { uploadConfirmed = {} } = trmDashboard || {};
    const { error, isLoading, data } = uploadConfirmed || {};
    if (error === null && isLoading === false && data !== null) {
      props.onConfirm();
      return {
        isConfirmed: true
      };
    } else if (error !== null && isLoading === false && data === null) {
      message.error(error.error);
      return {
        isConfirmed: false
      };
    }
    return null;
  }

  /**
   * onUploadAgain
   */
  onUploadAgain = () => {
    this.props.discardUploadedTypologies({
      data: this.props.uploadedData.filter((obj) => {
        return obj.state === 'Uploading';
      })
    });
    // this.props.clearUploadTypologies()
    this.props.onUploadAgain();
  };

  /**
   * disable button
   */
  disableButton = () => {
    let disableCount = 0;
    this.props.uploadedData.forEach((ele) => {
      if (ele.state === 'NoPermission') {
        disableCount += 1;
      }
    });
    return disableCount === this.props.uploadedData.length ? true : false;
  };

  /**
   * onConfirm
   */
  onConfirm = () => {
    const data = this.props.uploadedData.filter((obj) => {
      return obj.state === 'Ready';
    });
    if (data.length === 0) {
      message.error('Typology is already Uploaded');
      return;
    }
    this.props.confirmUploadedTypologies({ data: data });
  };

  render() {
    return (
      <Content className={style.content}>
        <div className={style.container}>
          <div className={style.uploadTypologyHeader}>
            <div>Typology Name</div>
            <div>Upload Status</div>
          </div>
          <List
            style={{ overflowX: 'scroll', height: 200 }}
            size="small"
            bordered
            dataSource={this.props.uploadedData}
            renderItem={(item, index) => (
              <List.Item
                style={{
                  boxShadow:
                    'inset 0px -1px 1px #D0D7E3, inset 1px 0px 1px #D0D7E3, inset -1px 0px 1px #D9D9D9',
                  backgroundColor: index % 2 === 0 ? 'white' : '#F7F7F8'
                }}>
                <div className={style.uploadListItem}>
                  <div>{item.title}</div>
                  <div>{item.state}</div>
                </div>
              </List.Item>
            )}
          />
          <div className={style.buttonContainer}>
            <ConfirmModal
              btnType={'secondary'}
              txt={'Upload Again'}
              onClick={this.onUploadAgain}
              style={{
                marginRight: 20,
                color: 'black',
                borderRadius: 4
              }}
            />

            <Button
              style={{ borderRadius: 4 }}
              type={'primary'}
              onClick={this.onConfirm}
              disabled={this.disableButton()}>
              Confirm
            </Button>
          </div>
        </div>
      </Content>
    );
  }
}

/**
 * propTypes
 */

UploadDataList.propTypes = {
  trmDashboard: Proptypes.object,
  confirmUploadedTypologies: Proptypes.func,
  discardUploadedTypologies: Proptypes.func,
  clearUploadTypologies: Proptypes.func,
  uploadedData: Proptypes.array,
  onConfirm: Proptypes.func,
  onUploadAgain: Proptypes.func
};

/**
 * mapStateToProps
 * @param state
 * @param ownProps
 * @returns {{typologyListingDashboard: *}}
 */
function mapStateToProps(state, ownProps = {}) {
  return {
    trmDashboard: state.trmDashboard
  };
}

/**
 * mapDispatchToProps
 * @param dispatch
 * @param ownProps
 * @returns {{dispatch: *}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    confirmUploadedTypologies: (payload) => {
      dispatch(confirmUploadedTypologies(payload));
    },
    discardUploadedTypologies: (payload) => {
      dispatch(discardUploadedTypologies(payload));
    },
    clearUploadTypologies: (payload) => {
      dispatch(clearUploadTypologies());
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadDataList);
